import React, { FC } from 'react';

const HelpPage: FC = () => (
	<div data-testid="help-page">{intl.tr('pages.help.title')}</div>
);

export default HelpPage;
